import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import CircularTarotSpread from '../components/CircularTarotSpread';

const CircularReadingPage: React.FC = () => {
  const { user } = useAuth();
  const [spreadType, setSpreadType] = useState<'sim_nao' | 'tres_cartas' | 'livre'>('sim_nao');
  const [showSpread, setShowSpread] = useState(false);

  const handleStartReading = () => {
    setShowSpread(true);
  };

  const handleNewReading = () => {
    setShowSpread(false);
    setSpreadType('sim_nao');
  };

  const handleCardSelect = (card: any, position: number) => {
    console.log('Carta selecionada:', card, 'Posição:', position);
  };

  return (
    <div className="min-h-screen bg-gradient-mystical text-white">
      {/* Header */}
      <div className="flex items-center justify-between p-6 border-b border-white/20">
        <Link 
          to="/dashboard" 
          className="flex items-center gap-2 text-white/80 hover:text-white transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Voltar</span>
        </Link>
        <h1 className="text-2xl font-mystical font-bold">CONSULTA DE TAROT</h1>
        <div className="w-20"></div>
      </div>

      {!showSpread ? (
        <div className="flex flex-col items-center justify-center min-h-[80vh] px-4">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-md w-full">
            <h2 className="text-3xl font-mystical font-bold text-center mb-8">
              Olá, {user?.name || 'Consulente'}!
            </h2>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium mb-2">
                  Tipo de Consulta
                </label>
                <select
                  value={spreadType}
                  onChange={(e) => setSpreadType(e.target.value as 'sim_nao' | 'tres_cartas' | 'livre')}
                  className="w-full px-4 py-3 bg-white/20 border border-white/30 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-gold-500"
                >
                  <option value="sim_nao" className="bg-mystical-800">Sim ou Não (1 carta)</option>
                  <option value="tres_cartas" className="bg-mystical-800">Passado, Presente, Futuro (3 cartas)</option>
                  <option value="livre" className="bg-mystical-800">Consulta Livre</option>
                </select>
              </div>

              <button
                onClick={handleStartReading}
                className="w-full py-3 bg-gradient-to-r from-gold-600 to-gold-700 text-white font-semibold rounded-lg hover:from-gold-700 hover:to-gold-800 transition-all duration-300"
              >
                Iniciar Consulta
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-6">
          <CircularTarotSpread
            onCardSelect={handleCardSelect}
            title={`Consulta de ${user?.name || 'Consulente'}`}
            spreadType={spreadType}
            userName={user?.name || 'Consulente'}
          />
          
          <div className="flex justify-center mt-8">
            <button
              onClick={handleNewReading}
              className="px-6 py-3 bg-white/20 text-white font-semibold rounded-lg hover:bg-white/30 transition-all duration-300"
            >
              Nova Consulta
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CircularReadingPage;